import axios from "axios";
import { API_BASE_URL } from "../../config";

/**
 * The client's side of a proposal.
 *
 * Deliberately unauthenticated: the recipient is not a CMS user, and the link in
 * their email is the only thing standing in for a login. Nothing here sends a
 * token — attaching the rep's would be both wrong and useless.
 */

const message = (err, fallback) => {
  const status = err?.response?.status;
  const said = err?.response?.data?.message;
  if (status === 404) return said || "This link is not valid. Please ask for a fresh one.";
  if (status === 409) return said || "This proposal has already been answered.";
  if (status === 410) return said || "This proposal has expired. Please ask for an updated one.";
  return said || fallback;
};

/** @returns {{client_name, plan_name, amount, effective_status, expired}} */
export const fetchPublicProposal = async (token) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/public/proposals/${token}`);
    return res.data?.data || null;
  } catch (err) {
    throw new Error(message(err, "This proposal could not be opened."));
  }
};

/** @returns {{payment_link?: string}} */
export const acceptPublicProposal = async (token) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/public/proposals/${token}/accept`);
    return res.data?.data || {};
  } catch (err) {
    throw new Error(message(err, "The proposal could not be accepted."));
  }
};

export const rejectPublicProposal = async (token) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/public/proposals/${token}/reject`);
    return res.data?.data || {};
  } catch (err) {
    throw new Error(message(err, "The proposal could not be declined."));
  }
};
